import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { IonApp } from '@ionic/angular/standalone';

/**
 * Shell. IonApp supplies Ionic's root layout context (required for its components to size and theme
 * correctly); routed pages render into the standard router-outlet inside it.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [IonApp, RouterOutlet],
  template: `
    <ion-app>
      <router-outlet />
    </ion-app>
  `,
})
export class App {}
